import { AxiosResponse } from 'axios';
import {
  clearAllCookies,
  getAccessToken,
  getHomeAccountId
} from './cookie-service';
import axiosInstance from './axios-service';
import { errorMessages } from './constants';
import { UserRole, UserRoleAppFormat } from './enum';

export const isAuthenticated = (): boolean => {
  return !!getAccessToken();
};

export const getUserRole = (jobRole?: string): UserRole => {
  try {
    let role = UserRole.Member;
    if (jobRole) {
      switch (jobRole) {
        case UserRoleAppFormat.SuperAdmin:
          role = UserRole.SuperAdmin;
          break;
        case UserRoleAppFormat.Admin:
          role = UserRole.Admin;
          break;
        case UserRoleAppFormat.OperationsLead:
          role = UserRole.OperationsLead;
          break;
        case UserRoleAppFormat.ProjectManager:
          role = UserRole.ProjectManager;
          break;
        default:
          role = UserRole.Member;
          break;
      }
    }
    return role;
  } catch (err) {
    console.error(err);
    return UserRole.Member;
  }
};

export const signIn = async (): Promise<AxiosResponse> => {
  const res = await axiosInstance.post('authenticate');

  if (res?.data) {
    location.href = res?.data;
  } else {
    console.error(errorMessages.ErrorMessageInSignIn);
  }
  return res;
};

export const signOut = (url: string): void => {
  localStorage.removeItem('persist:root');
  clearAllCookies();
  location.href = url;
};

interface tokenRespone {
  idToken?: string;
  accessToken?: string;
}

export const refreshAccessToken = async (): Promise<tokenRespone> => {
  const homeAccountId = getHomeAccountId();
  try {
    const res = await axiosInstance.get(
      `refreshToken?homeAccountId=${homeAccountId}`
    );

    return {
      idToken: res?.data?.idToken,
      accessToken: res?.data?.accessToken
    };
  } catch (err) {
    return {};
  }
};

// export const refreshAccessToken = async (): Promise<tokenRespone> => {
//   try {
//     const res = await axiosInstance.post('manage-auth', {
//       operationName: 'FetchRefreshToken',
//       variables: {
//         homeAccount: {
//           homeAccountId: getHomeAccountId()
//         }
//       },
//       query: `mutation FetchRefreshToken($homeAccount: RefreshTokenInputTypeDto!) {
//                 tokenRefreshRequest(homeAccountId: $homeAccount) {
//                   idToken
//                   accessToken
//                 }
//               }`
//     });
//     return {
//       idToken: res?.data?.data?.tokenRefreshRequest?.idToken,
//       accessToken: res?.data?.data?.tokenRefreshRequest?.accessToken
//     };
//   } catch (err) {
//     return {};
//   }
// };
